export enum PromoCodeType {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
	DELIVERY_FEE = 'delivery_fee',
	BOGO = 'bogo',
	REWARD = 'reward',
	FREE_ARTICLE = 'free_article',
	COUPON = 'coupon',
}
